export const paymentsListSelector = (state) => state.feeCollection.list;
export const totalSumSelector = (state) => state.feeCollection.totalSum;
export const totalFineSelector = (state) => state.feeCollection.totalFine;
export const feeAllocationModeSelector = (state) =>
  state.feeCollection.feeAllocationMode;
export const extraFeeDropDownSelector = (state) =>
  state.feeCollection.extraFeeDropDown;

export const extraFeeDropDownLoadingFlag = (state) =>
  state.feeCollection.isLoading;
